module.exports = __webpack_public_path__ + "img/file-person-fill.1abc5405.svg";